import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./i18n"; // Import the i18n configuration
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import KeycloakProviderWrapper from "./KeycloakWrapper";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<KeycloakProviderWrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
